module.exports = "/work-site/img/noPic1.e068b8bb.png";